(function () {
    'use strict';

    // @ngInject
    Services.splitio = function splitio($window) {
        return $window.splitio || {};
    };


}());